import { render, staticRenderFns } from "./pageProperty.vue?vue&type=template&id=0486e57a&"
import script from "./pageProperty.vue?vue&type=script&lang=js&"
export * from "./pageProperty.vue?vue&type=script&lang=js&"
import style0 from "./pageProperty.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports